/*
 * *
 *   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *   ~  * No part of this publication may be reproduced, distributed,
 *   ~  * or transmitted in any form or by any means, including photocopying, recording,
 *   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *   ~  * except in the case of brief quotations embodied in critical
 *   ~  * reviews and certain other noncommercial uses permitted by copyright law.
 *   ~  * AUTHOR : bs
 *   ~  * DATE : 23/05/2025 18:58
 *
 */

import { inject, Injectable } from '@angular/core';
import {
  AoSharedDataService,
  DataEventEnum,
} from '@monorepo-projects/alwayson-shared';
import { StandardMenuService } from './standard-menu.service';
import { delay, mergeMap, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DataService extends AoSharedDataService {
  private _standardMenuService = inject(StandardMenuService);

  public override init(): void {
    this.loadSettings$()
      .pipe(
        delay(this.delay),
        mergeMap(() => this._loadMenu$()),
        delay(this.delay),
        mergeMap(() => this.loadCompanySettings$()),
      )
      .subscribe({
        next: () => {
          this.emitter$.next(DataEventEnum.allLoaded);
          this.isLoading = false;
        },
      });
  }

  public override clear(): void {
    super.clear();
    this._standardMenuService.clear();
  }

  private _loadMenu$(): Observable<boolean> {
    const emitter = new Subject<boolean>();
    this._standardMenuService.subscribe({
      next: (r) => {
        if (r) {
          this.emitter$.next(DataEventEnum.loadedMenu);
          emitter.next(true);
          return;
        }
      },
    });
    this.emitter$.next(DataEventEnum.loadingMenu);
    this._standardMenuService.initMenu();
    return emitter.asObservable();
  }
}
